import { MessageCircle, Phone, ShieldCheck, ListChecks } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { AppointmentForm } from "@/components/AppointmentForm";
import { SITE } from "@/config/site";
import { telLink } from "@/utils/whatsapp";

const STEPS = [
  { icon: ListChecks, title: "Fill the form", text: "Share the patient's details and your preferred date and time." },
  { icon: MessageCircle, title: "Send on WhatsApp", text: "Your request opens in WhatsApp — review it and press send." },
  { icon: ShieldCheck, title: "Get confirmation", text: "The hospital team confirms your appointment slot." },
];

export default function Appointments() {
  return (
    <>
      <Seo
        title={`Book an Appointment — ${SITE.name}`}
        siteName={SITE.name}
        description={`Request an appointment at ${SITE.name}, Kasdol via WhatsApp. Choose your doctor, date and time — the hospital will confirm your slot.`}
      />
      <PageHeader
        title="Book an Appointment"
        description="Request an appointment on WhatsApp in under a minute. No account or payment needed."
        crumbs={[{ label: "Appointments" }]}
      />

      <section className="py-14 sm:py-20" data-testid="appointments-section">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-3 lg:px-8">
          <div className="lg:col-span-2">
            <AppointmentForm />
          </div>
          <aside className="space-y-6 lg:sticky lg:top-32 lg:self-start">
            <div className="rounded-2xl border border-slate-200 bg-white p-6">
              <h2 className="font-heading text-lg font-semibold text-navy-900">How it works</h2>
              <ol className="mt-5 space-y-5">
                {STEPS.map(({ icon: I, title, text }, i) => (
                  <li key={title} className="flex items-start gap-4">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-navy-50 text-navy-800">
                      <I className="h-5 w-5" aria-hidden="true" />
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-navy-900">{i + 1}. {title}</p>
                      <p className="mt-1 text-xs leading-relaxed text-slate-500">{text}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
            <div className="rounded-2xl bg-navy-900 p-6 text-white">
              <h2 className="font-heading text-lg font-semibold">Prefer to call?</h2>
              <p className="mt-2 text-sm text-slate-300">Speak directly with the hospital team.</p>
              <a
                href={telLink}
                className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-navy-900 transition-colors hover:bg-emerald-100"
                data-testid="appointments-call-button"
              >
                <Phone className="h-4 w-4" aria-hidden="true" /> Call {SITE.phoneDisplay}
              </a>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}
